// extracted by mini-css-extract-plugin
export var hideEditor = "_lw-2";
export var infoIcon = "_lw-3";
export var label = "_lw-1";
export var labelContainer = "_lw-0";
export var readonlyText = "_lw-4";